import React, { Component } from 'react';

class Service extends Component {
  render() {
    const { amount_lack, total_amount, total_donor } = this.props.data;
    return (
      <section id="services">
        <div className="container">
          <div className="row">
            <a href="#" className="col-md-4 services_box">
              <img className="services_avatar" src="assets/active-donate1.png" alt="donate" />
              <h5 className="h5-reponsive mt-4 services_title">Kekurangan Dana</h5>
              <h5 className="h5-reponsive mt-4 services_desc">Rp -{ (amount_lack) ? amount_lack.toFixed().replace(/(\d)(?=(\d{3})+(,|$))/g, '$1.') : '' }</h5>
            </a>
            <a href="#" className="col-md-4 services_box">
              <img className="services_avatar2" src="assets/terkumpul.png" alt="terkumpul" />
              <h5 className="h5-reponsive mt-4  services_title">Wakaf Yang Telah Dikelola</h5>
              <h5 className="h5-reponsive mt-4 services_desc">Rp { (total_amount) ? total_amount.toFixed().replace(/(\d)(?=(\d{3})+(,|$))/g, '$1.') : '' }</h5>
            </a>
            <a href="#" className="col-md-4 services_box">
              <img className="services_avatar3" src="assets/muhsinin.png" alt="muhsinin" />
              <h5 className="h5-reponsive mt-4  services_title">Muhsinin Tergabung</h5>
              <h5 className="h5-reponsive mt-4 services_desc">{ total_donor }+</h5>
            </a>
          </div>
        </div>
      </section>
    )
  }
}

export default Service;



// WEBPACK FOOTER //
// ./src/components/Service.js